import { Component, inject, Inject, OnDestroy } from '@angular/core';
import { NgFor } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Trail } from '../../dto/trail';
import { ReportCompleted, ReportProgress, ReportStreamService } from '../../service/report-stream.service';
import { ReportRequest } from '../../dto/report-request';

@Component({
  selector: 'dpi-trial-report-dialog',
  imports: [FormsModule, MatButtonModule, MatIconModule, MatDialogModule, MatRadioModule, NgFor, MatProgressBarModule],
  templateUrl: './trial-report-dialog.component.html',
  styleUrl: './trial-report-dialog.component.scss'
})
export class TrialReportDialogComponent  implements OnDestroy {
  readonly dialogRef = inject(MatDialogRef<TrialReportDialogComponent>);
  trial : Trail;
  
  selectedFormat = 'NDT';
  formatList = [
    { label: 'N-Denton', value: 'NDT' },
    { label: 'DNV', value: 'DNV' }
  ];

  
  isSuccessful : boolean = false;
  running = false;
  percent = 0;
  stage = '';
  status : ReportProgress | undefined ;
  result?: ReportCompleted;
  error = '';
  
  private ctrl?: AbortController;

  constructor(@Inject(MAT_DIALOG_DATA) public data: Trail, 
    private readonly stream: ReportStreamService
  ) {
    this.trial = data;
  }

  ngOnDestroy(): void {
    this.ctrl?.abort(); // 组件销毁必须断流，否则后台白跑任务
  }

  start(): void {
    this.running = true;
    this.error = '';
    this.result = undefined;
    this.percent = 0;
    this.stage = 'Conncting...';

    let reportRequest  : ReportRequest = {
      trialId: this.trial.id,
      reportType: this.selectedFormat,
    };

    this.ctrl = this.stream.generateStream(
      reportRequest,
      {
        onProgress: (p: ReportProgress) => {
          this.percent = p.percent;
          this.stage = p.stage;
        },
        onCompleted: (c: ReportCompleted) => {
          this.running = false;
          this.percent = 100;
          this.stage = 'Report generation completed!';
          this.result = c;
          this.isSuccessful = true; // 成功标志
          this.dialogRef.close();
        },
        onFailed: (message: string) => {
          this.running = false;
          this.stage = message;
          this.isSuccessful = false;;
        },
        onUnauthorized: () => {
          this.running = false;
          this.stage = 'Unauthorized. Please login again.';
          this.isSuccessful = false;
          // 可在这里跳转登录页
        },
      },
    );
  }

  cancel(): void {
    this.ctrl?.abort();
    this.running = false;
    this.stage = 'Cancelled';
    this.isSuccessful = false;
    this.dialogRef.close(); // 关闭对话框
  }

}
